<div class="app-default">
  <app-header></app-header>
  <main>
    <app-settings></app-settings>
    <router-outlet></router-outlet>
  </main>
</div>
